import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import * as debug from 'src/app/shared/services/debug.service';

@Pipe({ name: 'base64' })
export class Base64Pipe implements PipeTransform {
	constructor(private domSanitizer: DomSanitizer) { }

	transform(image: string): SafeStyle {
		// const pattern = /data:image\/.*;base64,/gi;
		const defaultImage = `url("/assets/img/users/default-user.jpg")`;

		// let userProfile = image;

		// if (!pattern.test(image)) {
		//     userProfile = `url("data:image/png;base64,${image}")`;
		// } else {
		//     userProfile = `url("${image}")`;
		// }

		const backgroundImage = !!image ? `url("${image}")` : defaultImage;

		return this.domSanitizer.bypassSecurityTrustStyle(backgroundImage);
	}
}
